const formatCurrency = (value, currency = 'GBP') =>
  new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency,
  }).format(value);

export default formatCurrency;
